import React from 'react';
import useSeo from '../hooks/useSeo';

export default function TermsConditions() {
  useSeo({
    title: 'Terms & Conditions',
    description: "Terms of use, refund policy, and privacy notice for It's a Simcha custom Jewish invitation templates.",
    path: '/terms-conditions',
  });
  return (
    <div style={{ maxWidth: 800, margin: '40px auto', padding: '0 20px', fontFamily: 'Verdana, Arial, sans-serif', lineHeight: 1.7 }}>
      <h1>Terms &amp; Conditions</h1>
      <p>By using It's a Simcha you agree to the following terms. Purchased templates may be edited a limited number of times per order. Downloads are for personal use; redistribution or resale is prohibited. Contact system@itsasimcha.net with any questions.</p>
      <h2>Refunds</h2>
      <p>Because templates are delivered digitally and immediately editable, all sales are final once download has started. Reach out to support if you encounter a defect.</p>
      <h2>Privacy</h2>
      <p>We collect the information you enter into our editor solely to generate your invitation. We do not sell your data to third parties.</p>
    </div>
  );
}
